// ** Initial State
import {dataUtils} from "../../../applyoo/js/dataUtils";
import {store} from "../../storeConfig/store";
import {executeApplyooComponentsFunction} from "../../../applyoo/infrastructure/useApplyooComponent";
import {utils_ui} from "../../../applyoo/utils/utils_ui";

const initialState = {
    dicRepositoryItems : {} ,
    dicRepositoryItemsForKeyValue : {} ,
    repositoryItemsStr: "",
}

const combineKeys=(prmExsitingKeys,prmNewKeys) => {
    let outVal = "";

    if (!!prmNewKeys){
        outVal = prmExsitingKeys.join() + "," + prmNewKeys.join();
    }

    return outVal;
}

const createRepositoriesForKeyValue=(prmDsRepositoryItems ,prmDicRepositoryKeys, prmDicExistingRepoItemsForKeyValue) => {
    let dicOut = prmDicExistingRepoItemsForKeyValue;
    // prmDicRepositoryKeys is always undefined
    for (const currKey in prmDsRepositoryItems) {
        if (prmDicRepositoryKeys &&!!prmDicRepositoryKeys[currKey]
            && !!prmDicRepositoryKeys[currKey]?.KeyField
            && !!prmDicRepositoryKeys[currKey]?.DisplayField) {

            let lstItems = [];
            let lstRepoItem = prmDsRepositoryItems[currKey];
            let keyFieldName = prmDicRepositoryKeys[currKey]?.KeyField;
            let textFieldName = prmDicRepositoryKeys[currKey]?.DisplayField;

            lstItems.push({
                "value": null,
                "text": " ",
                "label": " ",
            });

            for (const currRepoItem of lstRepoItem) {
                let currLabel = currRepoItem[textFieldName]

                if (currRepoItem.hasOwnProperty("AP_LangKey")
                    && !!currRepoItem["AP_LangKey"]){
                    currLabel = utils_ui.getLanguageTitle(currRepoItem["AP_LangKey"])
                }

                let newItem = {
                    "value": currRepoItem[keyFieldName],
                    "text": currLabel,
                    "label": currLabel,
                    "row": currRepoItem
                }

                lstItems.push(newItem);
            }

            // for (let ind01 = 0; ind01 < currRepoItem.length; ind01++) {
            //     let currRepoItem = currRepoItem[ind01]
            //     let currLabel = currRepoItem[textFieldName]
            //
            //     if (currRepoItem.hasOwnProperty("AP_LangKey")
            //             && !!currRepoItem["AP_LangKey"]){
            //         currLabel = utils_ui.getLanguageTitle(currRepoItem["AP_LangKey"])
            //     }
            //
            //     let newItem = {
            //         "value": currRepoItem[keyFieldName],
            //         "text": currRepoItem[textFieldName],
            //         "label": currLabel,
            //         "row": currRepoItem
            //     }
            //
            //     lstItems.push(newItem);
            // }

            dicOut[currKey] = lstItems;
        }
    }

    return dicOut;
}

export const store_Repositories = (state = initialState, action) => {
    function CreateRepositoriesForKeyValue(DsRepositoryItems, dicRepositoryKeys) {
        return undefined;
    }

    switch (action.type) {
        case 'FREE_MEMORY':
            return {...state, initialState};

        case 'UPDATE_VIRTUAL_REPOSITORY_ITEMS':
            let dicNewRepoForKeyValue2 = createRepositoriesForKeyValue(action.DsRepositoryItems, state.dicRepositoryKeys,state.dicRepositoryItemsForKeyValue);
            let existingRepoStr2 = combineKeys(Object.keys(state.dicRepositoryItems) ,Object.keys(action.DsRepositoryItems));
            let newRepoItems2 = {...state.dicRepositoryItems, ...action.DsRepositoryItems}

            const newRepoState2 = { ...state, repositoryItemsStr: existingRepoStr2, dicRepositoryItems: newRepoItems2, dicRepositoryItemsForKeyValue: dicNewRepoForKeyValue2 }

            return newRepoState2

        case 'UPDATE_REPOSITORY_ITEMS':
            let dicNewRepoForKeyValue = createRepositoriesForKeyValue(action.DsRepositoryItems, state.dicRepositoryKeys,state.dicRepositoryItemsForKeyValue);
            let existingRepoStr = combineKeys(Object.keys(state.dicRepositoryItems) ,Object.keys(action.DsRepositoryItems));
            let newRepoItems = {...state.dicRepositoryItems, ...action.DsRepositoryItems}

            const newRepoState = { ...state, repositoryItemsStr: existingRepoStr, dicRepositoryItems: newRepoItems, dicRepositoryItemsForKeyValue: dicNewRepoForKeyValue }

            const timerId = setTimeout(() => {
                executeApplyooComponentsFunction("repositoryChanged",{...newRepoState, dicNewRepoForKeyValue:dicNewRepoForKeyValue})
                clearTimeout(timerId)
            }, 10)

            return newRepoState

        case 'GET_PROJECT_REPOSITORY_METADATA':
            let dicObj = dataUtils.convertArrayToDicObject(action.DsRepositoryItems?.dtRepositoryKeys, "EntityName")
            return { ...state, dicRepositoryKeys: dicObj}

        case 'ADD_VIRTUAL_REPOSITORY_ITEMS':

            let dicNewVirtualRepoForKeyValue = {...state.dicRepositoryItemsForKeyValue,...action.dicVirtualRepoForKeyValue}
            //dictionary key will be VIRTUAL_REPOSITORY_ITEM_FieldName example: VIRTUAL_REPOSITORY_ITEM_ExtField_e955
            return { ...state, dicRepositoryItemsForKeyValue: dicNewVirtualRepoForKeyValue }

        case 'UPDATE_SYSTEM_TABLE_REPOSITORY_ITEMS':
            let newStateWithSysTables = {...state}

            for (const newRepositoryTableName in action.dicAccountTablesRepositoryItems) {
                let newRepoInfoObj = action.dicAccountTablesRepositoryItems[newRepositoryTableName]

                newStateWithSysTables.dicRepositoryItems[newRepositoryTableName] = newRepoInfoObj?.DtData
                newStateWithSysTables.dicRepositoryItemsForKeyValue[newRepositoryTableName] = newRepoInfoObj?.DtDataAsKeyValue
            }

            const timerId2 = setTimeout(() => {
                executeApplyooComponentsFunction("repositoryChanged",{...newStateWithSysTables, dicNewRepoForKeyValue: newStateWithSysTables.dicRepositoryItemsForKeyValue})
                clearTimeout(timerId2)
            }, 10)

            return { ...newStateWithSysTables}

        case 'REMOVE_VIRTUAL_REPOSITORY_ITEMS':
            let tempDicRepoForKeyValue = {...state.dicRepositoryItemsForKeyValue}
            for (let dicRepositoryItemsForKeyValueKey in state.dicRepositoryItemsForKeyValue) {
                if(dicRepositoryItemsForKeyValueKey.startsWith("virtualList_")){
                    delete tempDicRepoForKeyValue[dicRepositoryItemsForKeyValueKey]
                }
            }
            return { ...state,dicRepositoryItemsForKeyValue: tempDicRepoForKeyValue }

        default:
            return state
    }
}

// export default store_Repositories
